import { SelectionModel } from '@angular/cdk/collections'
import * as R from 'ramda'
import { MatTableDataSource } from '@angular/material/table'
import { ManagedTable } from './managed-table'
import { ITableService } from './table.service'
import { IUserStorage } from '../interfaces/user.storage'

// @todo - this shouldn't depend on tableService
export abstract class SelectableRow<T = any> extends ManagedTable {
  selection = new SelectionModel<T>(true, [])
  dataSource: MatTableDataSource<T>

  renderedData: T[]

  selectableRowIdPropName: string

  constructor(protected tableService: ITableService, protected storage: IUserStorage, protected tableType?: string) {
    super(storage, tableType)
  }

  protected isRowSelectable(row: T) {
    return true
  }

  setDataSource(dataSource) {
    this.dataSource = dataSource
    this.dataSource['_renderData'].subscribe((rows) => {
      this.renderedData = rows
    })
    this.dataSource['_data'].subscribe(() => {
      this.selection = new SelectionModel<T>(true, [])
    })
  }

  getTableData(onlyRenderedData) {
    return onlyRenderedData ? this.renderedData : this.dataSource.filteredData
  }

  isAnySelected() {
    const selectedItems = R.filter(this.isRowSelectable, this.selection.selected)
    return !R.isEmpty(selectedItems) && !R.isNil(selectedItems)
  }

  isAllSelected(onlyRenderedData = true) {
    return (
      this.isAnySelected() &&
      this.tableService.isAllSelected(this.selection, this.getTableData(onlyRenderedData), this.isRowSelectable)
    )
  }

  masterToggle(onlyRenderedData = true) {
    this.tableService.masterToggle(
      this.selection,
      this.getTableData(onlyRenderedData),
      this.dataSource,
      this.isRowSelectable,
      this.selectableRowIdPropName
    )
  }

  unselectAll() {
    this.selection.clear()
  }

  getSelected(field?: string) {
    let selectedItems: T[] = []

    if (field) {
      selectedItems = R.map((hold) => hold[field], this.selection.selected)
    } else {
      selectedItems = this.selection.selected
    }

    return R.filter(this.isRowSelectable, selectedItems)
  }
}
